import { ClearDriveAction, CLEAR_DRIVE } from './types'

export const clearDrive = (): ClearDriveAction => {
	return {
		type: CLEAR_DRIVE
	}
}
